import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoverImage } from './imageWithMenu/CoverImage';
import { CoverImageLabel } from './imageWithMenu/CoverImageLabel';
import { NavigationMenu } from './imageWithMenu/NavigationMenu';

const ImageWithMenu = ({
  title,
  imageUrl,
  imageAltText,
  hearingTypeName,
  subjectAreaName,
  cityAreaName,
  disableSummary,
  disableConclusion,
  disableHearingText,
  disableCommentSection,
  disableNavigationMenu,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div className=" hearing-details-image-container">
      <div className="container-hearing-image-text">
        <CoverImage
          alt={
            imageAltText || translator('hearingProperties.hearingImageAltText')
          }
          imageUrl={imageUrl}
        />
        <h2 className="bottom-left-hearing-image-text">{title}</h2>
        <div className="bottom-right-hearing-label">
          {hearingTypeName !== '-' && (
            <CoverImageLabel text={hearingTypeName} />
          )}
          {subjectAreaName !== '-' && (
            <CoverImageLabel text={subjectAreaName} />
          )}
          {cityAreaName !== '-' && <CoverImageLabel text={cityAreaName} />}
        </div>
      </div>
      {!disableNavigationMenu && (
        <NavigationMenu
          disableSummary={disableSummary}
          summaryAnchor={'#summary'}
          disableConclusion={disableConclusion}
          conclusionAnchor={'#conclusion'}
          disableHearingText={disableHearingText}
          hearingTextAnchor={'#hearingText'}
          disableCommentSection={disableCommentSection}
          commentSectionAnchor={'#commentSection'}
        />
      )}
    </div>
  );
};

export { ImageWithMenu };
